import { render, staticRenderFns } from "./VAT01.vue?vue&type=template&id=632461f2&scoped=true"
import script from "./VAT01.vue?vue&type=script&lang=js"
export * from "./VAT01.vue?vue&type=script&lang=js"
import style0 from "./VAT01.vue?vue&type=style&index=0&id=632461f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632461f2",
  null
  
)

export default component.exports